import { Fragment } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
import { LinkTermTypesEnum } from 'root/src/client/v2/drop/components/SponsorshipTerms/types';
import { getTermTextMappedWithLinks, replaceLinkTypesToHref, } from 'root/src/client/v2/drop/components/SponsorshipTerms/helpers';
// Redesign of `SponsorshipTerms`: reuses the same term evaluation + link resolution, but renders
// a clean check-list (small green check + text) instead of the legacy big coloured dots.
export const RedesignSponsorshipTerms = ({ terms, dropEvent, shortUrl, canEarnPoints, isTermsAccepted, canUserReclaimReservation = false, streamDate, pointsReservationDueDate, }) => {
    const linkTypes = { [LinkTermTypesEnum.SHORT_LINK]: shortUrl };
    return (<div className="flex flex-col">
			<ul className="flex flex-col divide-y divide-solid divide-white/[0.06]">
				{terms.map((term) => {
            var _a;
            const isVisible = typeof term.visibilityCondition !== 'undefined'
                ? term.visibilityCondition({
                    dropEvent, canEarnPoints, isTermsAccepted, canUserReclaimReservation, shortUrl, streamDate, pointsReservationDueDate,
                })
                : true;
            if (!isVisible) {
                return null;
            }
            const textMod = typeof term.text === 'function'
                ? term.text({ dropEvent, streamDate, pointsReservationDueDate, isTermsAccepted })
                : term.text;
            if (!textMod) {
                return null;
            }
            const links = replaceLinkTypesToHref((_a = term.links) !== null && _a !== void 0 ? _a : [], linkTypes);
            const parts = getTermTextMappedWithLinks(textMod, links);
            return (<li key={textMod} className="flex items-start gap-2 py-2 text-xs leading-relaxed text-muted-foreground first:pt-0 last:pb-0">
							<CheckIcon sx={{ fontSize: 13 }} className="mt-0.5 shrink-0 text-neon-green"/>
							<span>
								{parts.map(({ textPart, href }) => (href
                    ? <a key={href} href={addHttpsProtocol(href)} target="_blank" rel="noopener noreferrer" className="break-all text-neon-cyan underline">{href}</a>
                    : <Fragment key={textPart}>{textPart}</Fragment>))}
							</span>
						</li>);
        })}
			</ul>
			{canEarnPoints && (<a href="https://daredrop.com/points-program" target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-neon-cyan underline-offset-2 hover:underline">
					Learn more about points
					<InfoOutlinedIcon sx={{ fontSize: 14 }}/>
				</a>)}
		</div>);
};
